import * as React from 'react';

interface VodafoneProps extends React.SVGProps<SVGSVGElement> {
  /**
   * Use this to edit the svg with equal height and width
   */
  size?: number;
}

const Vodafone = ({ fill = '#e60000', size = 18, ...rest }: VodafoneProps) => {
  return (
    <svg width={size} height={size} viewBox='0 0 18 18' {...rest}>
      <path
        d='M9 0a9 9 0 110 18A9 9 0 019 0zm3.208.794C10.335.8 8.269 1.6 6.762 2.849 5.216 4.13 4.007 6.286 4.015 8.527c.01 3.39 2.584 5.5 5.056 5.492 3.053-.01 4.86-2.517 4.852-4.805-.008-2.288-1.252-3.942-3.992-4.61a.932.932 0 01-.011-.146c-.006-1.73 1.297-3.253 2.935-3.593-.154-.052-.406-.072-.647-.071z'
        fill={fill}
        fillRule='evenodd'
      />
    </svg>
  );
};

const MemoVodafone = React.memo(Vodafone);
export default MemoVodafone;
